import * as tracking from 'dibs-tracking';

const heroList = 'Large Item Carousel';

function buildProductTrackingData({ item, index, list }) {
    const product = {
        dimension83: item.contemporaryTrackingString,
        url: item.link,
        name: item.title,
        position: index + 1,
        list,
    };

    return product;
}

function trackProductImpression({ items, startIndex }) {
    tracking.trackEcommerce({
        type: 'productImpression',
        products: items.map((item, index) =>
            buildProductTrackingData({
                item,
                index: startIndex + index,
                list: heroList,
            })
        ),
    });
}

function trackProductClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'productClick',
        actionField: { list: heroList, itemId: item.itemId },
        products: [buildProductTrackingData({ item, index })],
    });
}

export { trackProductImpression, trackProductClick };
